import React, { Component, useState, Fragment } from "react";
import PersonalContext from "./PersonalContext";
import WidgetSummary from "../../components/WidgetSummary";
import { Accordion, Card } from "react-bootstrap";
import UserIcon from "../../images/user_icon.svg";
import ChevonDown from "../../images/chevron-down.svg";
import Edit from "../../images/edit.svg";
import BenefitBlock from "../../components/BenefitBlock";
import CheckBoxInsuranceConfirm from "../../components/CheckBoxInsuranceConfirm";
import CheckBoxTax from "../../components/CheckBoxTax";
import TaxReciept from "../../components/TaxReciept";
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT, DATE_FORMAT } from "../../const";
import CheckBoxReceived from "../../components/CheckBoxReceived";
import DataService from "../../service/data";
import moment from "moment";

const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class PersonalStep3 extends Component {
  callBackAction;
  state = {
    benefitTitles: []
  };
  constructor(props) {
    super(props);
    setTimeout(() => {
      this.initData();
    }, 1);
  }
  async initData() {
    try {
      const response = await DataService.getTitle({ lang: "", type: "B" })
      const benefitTitles = response.filter(data => data.lang === "TH");
      this.setState({
        ...this.state,
        benefitTitles: benefitTitles
      });
    } catch (err) {
      console.log(err);
    }
  }
  render() {
    const { benefitTitles } = this.state;
    const { step1, step2, step3 } = this.context;
    const {
      recieveEmail,
      recievePost,
      confirmInsurance,
      taxDeduction,
      taxReciept,
      onChangeModel,
      onNavigate
    } = step3;
    const {
      sIDNo = "",
      sSex,
      sInitNameTH = "",
      sFirstNameTH = "",
      sLastNameTH = "",
      sBirthDate = "",
      sOccupation = "",
      sMobile = "",
      sEmail = "",
      sStart_date = "",
      sEnd_date = "",
    } = step2;
    const {
      sNo = "",
      sMoo = "",
      sSoi = "",
      sRoad = "",
      sProvince = "",
      sDistrict = "",
      sCity = "",
      sZipcode = ""
    } = step2;
    const { benefits } = step2;

    const no = sNo ? `เลขที่ ${sNo} ` : ``;
    const moo = sMoo ? `หมู่ ${sMoo} ` : ``;
    const soi = sSoi ? `ซอย ${sSoi} ` : ``;
    const road = sRoad ? `ถนน${sRoad} ` : ``;
    const subDistrict = sDistrict ? `แขวง${sDistrict.label} ` : ``;
    const district = sCity ? `เขต${sCity.label} ` : ``;
    const province = sProvince ? `${sProvince.label} ` : ``;
    const zipcode = sZipcode ? `${sZipcode} ` : ``;
    const address = `${no}${moo}${soi}${road}${subDistrict}${district}${province}${zipcode}`;
    const { selectedPlan, planList } = step1;
    const planDetail =
      planList.filter(plan => plan.id === selectedPlan)[0] || {};
    const { insured, total, medicalExpense } = planDetail;
    const totalAmount = total;
    const diffDate = sBirthDate
      ? moment.utc().diff(moment(sBirthDate), "years")
      : "-";
    return (
      <Fragment>
        <div className="form-wrapper info">
          <div className="form-group">
            <label>ทุนประกัน</label>
            <label className="value">
              {CurrencyUtils.currency(insured)} บาท
            </label>
          </div>

          <div className="form-group">
            <label>ค่ารักษาพยาบาล</label>
            <label className="value">
              {CurrencyUtils.currency(medicalExpense)} บาท
            </label>
          </div>

          <div className="form-group">
            <label>ระยะเวลาเอาประกัน</label>
            <label className="value">
              {moment(sStart_date).format(DATETHAI_FORMAT)} -{" "}
              {moment(sEnd_date).format(DATETHAI_FORMAT)}
            </label>
          </div>
          <div className="summary-reactagle">
            <div className="form-group">
              <label>รายการเบี้ยประกันรวม</label>
              <label className="totalPrice">
                {CurrencyUtils.currency(totalAmount)} บาท
              </label>
              <label className="help">
                (เบี้ยประกันภัยรวมภาษีและอากรแสตมป์แล้ว)
              </label>

              <WidgetSummary planDetail={planDetail} />
            </div>
          </div>
          <div className="form-group">
            <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
              <Card className="accordion-item" key={"0"}>
                <div className="d-flex align-item-center ml-3">
                  <Icon src={UserIcon} />
                  <p className="header-accordion-text">ข้อมูลผู้เอาประกัน</p>
                  <div className="ml-auto mr-3" onClick={() => onNavigate(2)}>
                    <Icon src={Edit} />
                  </div>
                  <Accordion.Toggle
                    className="pl-0"
                    as={Card.Header}
                    eventKey={"0"}
                  >
                    <Icon src={ChevonDown} />
                  </Accordion.Toggle>
                </div>
                <Accordion.Collapse eventKey={"0"}>
                  <Card.Body className="accordion-body">
                    <div className="form-group">
                      <label>บัตรประชาชน</label>
                      <p>{sIDNo}</p>
                    </div>
                    <div className="form-group">
                      <label>ชื่อ-สกุล (ภาษาไทย)</label>
                      <p>
                        {sInitNameTH.label}{sFirstNameTH} {sLastNameTH}
                      </p>
                    </div>

                    <div className="form-group">
                      <label>วันเกิด</label>
                      <p>
                        {moment(sBirthDate)
                          .locale("th")
                          .add(543,'year')
                          .format(DATE_FORMAT)}
                      </p>
                    </div>
                    <div className="form-group">
                      <label>อายุ</label>
                      <p>{diffDate} ปี</p>
                    </div>
                    <div className="form-group">
                      <label>เบอร์โทรศัพท์</label>
                      <p>{sMobile}</p>
                    </div>
                    <div className="form-group">
                      <label>อีเมล</label>
                      <p>{sEmail}</p>
                    </div>
                    <hr />
                    <div className="form-group">
                      <label>ที่อยู่ผู้เอาประกันและจัดส่งกรมธรรม์</label>
                      <p>{address}</p>
                    </div>
                    {/* Benefit Section */}
                    {benefits.map((benefit, index) => {
                      return benefit ? (
                        <BenefitBlock
                          key={index}
                          index={index}
                          benefit={benefit}
                        />
                      ) : (
                        ""
                      );
                    })}

                    <hr />
                    <div className="form-group">
                      <label>อีเมลสำหรับข้อมูลกรมธรรม์</label>
                      <p>{sEmail}</p>
                    </div>
                    <div className="form-group">
                      <label>เบอร์ติดต่อ</label>
                      <p>{sMobile}</p>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
          {/* <CheckBoxReceived
            recieveEmail={recieveEmail}
            recievePost={recievePost}
            onChangeModel={onChangeModel}
          /> */}
          <CheckBoxTax
            onChangeModel={onChangeModel}
            checked={taxDeduction}
          />
          <TaxReciept
            checked={taxDeduction}
            reciever={taxReciept}
            onChangeModel={onChangeModel}
            benefitTitles={benefitTitles}
            step3={step3}
          />
        </div>
        <div className="form-wrapper">
          <div className="form-group">
            <CheckBoxInsuranceConfirm
              checked={confirmInsurance}
              onCheckChange={checked =>
                onChangeModel({ name: "confirmInsurance", value: checked })
              }
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

PersonalStep3.contextType = PersonalContext;
export default PersonalStep3;
